import { useAuth } from './useAuth';

export const useUserProfile = () => {
  const { user } = useAuth();
  if (user === null) throw new Error('User logged out.');
  if (user.role == null) throw new Error('No user role found');

  return user;
};
